// @ts-nocheck
import React from 'react';
import { Box } from '@mui/material';
import { AddIcon } from 'assets/icons';
import { imageFormats } from '../CommonAttachment/constants';

const AttachmentInput = ({
  classes,
  attachmentHandler,
  values,
  setValues,
  inputId = 'attachment',
  attachmentTitle,
}) => {
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.classList.add(classes.dragOver);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.classList.add(classes.dragOver);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.classList.remove(classes.dragOver);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.classList.remove(classes.dragOver);
    attachmentHandler({ target: { files: e.dataTransfer.files } });
  };

  return (
    <Box
      className={classes.attachmentContainer}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <label htmlFor={inputId} className={classes.attachmentContainerText}>
        <AddIcon fontSize="small" color="action" />
        <span className={classes.dropFileText}>{attachmentTitle}</span>
      </label>
      <input
        type="file"
        id={inputId}
        accept={`.${imageFormats.join(', .')}`}
        multiple
        className={classes.fileInput}
        onChange={(e) => {
          attachmentHandler(e);
          setValues(e.target.value);
        }}
        value={values}
      />
    </Box>
  );
};
export default AttachmentInput;
